import React, { useState } from "react";
import RiseModal from "../../RiseModal/RiseModal";
import { useTranslation } from "react-i18next";

const ColumnsModal = ({
  onClose,
  filteredCols,
  handleColChecked,
  handleShowAllCols,
  style,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const { t } = useTranslation("common");
  const visibleCols = searchTerm
    ? filteredCols?.filter((item) =>
        item.label.toLowerCase().includes(searchTerm.toLowerCase()),
      )
    : filteredCols;

  return (
    <RiseModal onClose={onClose} closeOnLeave={false} style={style}>
      <div
        className="w-[230px] max-w-[85vw] overflow-hidden rounded-lg border border-ui-border bg-ui-surface-raised shadow-ui-md"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-ui-border px-3.5 py-2.5">
          <span className="text-xs font-semibold text-ui-text">
            {t("table.columns")}
          </span>
          <div className="flex items-center gap-2 text-[11px] font-medium">
            <button
              type="button"
              className="text-brand hover:underline"
              onClick={() => handleShowAllCols(true)}
            >
              {t("actions.showAll")}
            </button>
            <span className="text-ui-text-subtle">|</span>
            <button
              type="button"
              className="text-ui-text-muted hover:text-state-danger-text hover:underline"
              onClick={() => handleShowAllCols(false)}
            >
              {t("actions.hideAll")}
            </button>
          </div>
        </div>

        <div className="px-2.5 pt-2.5">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder={t("table.searchColumn")}
            className="w-full rounded-md border border-ui-border px-2.5 py-1.5 text-xs text-ui-text outline-none transition-colors focus:border-brand focus:ring-1 focus:ring-brand/[0.08]"
          />
        </div>

        <div className="thin__scrollbar max-h-64 overflow-y-auto py-1.5">
          {visibleCols?.map((item) => (
            <label
              key={item.id}
              className="flex cursor-pointer items-center gap-2.5 px-3.5 py-1.5 text-xs text-ui-text transition-colors hover:bg-ui-row-hover"
            >
              <input
                type="checkbox"
                className="h-3.5 w-3.5 shrink-0 cursor-pointer accent-brand"
                checked={item.checked !== false}
                onChange={(e) => handleColChecked(item.id, e.target.checked)}
              />
              <span className="truncate">{item.label}</span>
            </label>
          ))}
        </div>
      </div>
    </RiseModal>
  );
};

export default ColumnsModal;
